<template>
  <div class="employer-first-steps  container">
    <div class="employer-first-steps__content  container-inner">
      <div class="employer-first-steps__item  _active">
        <div class="employer-first-steps__item-check">
          <BaseSvg name="ico-tick"/>
        </div>
        {{ $tGlobal('employer-first-steps__step-1') }}
        <div class="employer-first-steps__item-content">

        </div>
      </div>
      <div :class="{_active: emailVerified}"
           class="employer-first-steps__item">
        <div class="employer-first-steps__item-check">
          <BaseSvg name="ico-tick"/>
        </div>
        {{ $tGlobal('employer-first-steps__confirm-email') }}
        <div class="employer-first-steps__item-content">

        </div>
      </div>
      <router-link-modified :to="{name: 'account-new-vacancy'}"
                            :class="{_active: hasVacancy}"
                            class="employer-first-steps__item">
        <div class="employer-first-steps__item-check">
          <BaseSvg name="ico-tick"/>
        </div>
        {{ $tGlobal('employer-first-steps__step-2') }}
        <div class="employer-first-steps__item-content">

        </div>
      </router-link-modified>
      <router-link-modified :to="{name: 'account-employer-profile-edit'}"
                            :class="{_active: hasCompletedProfile}"
                            class="employer-first-steps__item">
        <div class="employer-first-steps__item-check">
          <BaseSvg name="ico-tick"/>
        </div>
        {{ $tGlobal('employer-first-steps__step-3') }}
        <div class="employer-first-steps__item-content">

        </div>
      </router-link-modified>
      <div :class="{_active: isHasVerifiedVacancy}"
           class="employer-first-steps__item">
        <div class="employer-first-steps__item-check">
          <BaseSvg name="ico-tick"/>
        </div>
        {{ $tGlobal('employer-first-steps__verification-passed') }}
        <div class="employer-first-steps__item-content">

        </div>
      </div>
      <div :class="{_active: hasPublishedVacancy}"
           class="employer-first-steps__item">
        <div class="employer-first-steps__item-check">
          <BaseSvg name="ico-tick"/>
        </div>
        {{ $tGlobal('employer-first-steps__has-published-vacancy') }}
        <div class="employer-first-steps__item-content">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from "@/axios"

  export default {
    name: 'EmployerFirstStepsStepsPreview',
    computed: {
      employerChecklist() {
        return this.$store.state.user.employerChecklist
      },
      hasVacancy() {
        return this.employerChecklist.have_vacancies
      },
      hasCompletedProfile() {
        return this.employerChecklist.email_verify_complete_profile
      },
      isHasVerifiedVacancy() {
        return this.employerChecklist.moderator_verify_profile
      },
      hasPublishedVacancy() {
        return this.employerChecklist.vacancy_published
      },
      emailVerified() {
        return this.employerChecklist.email_verify;
      },
    },
    methods: {
      setShowed() {
        http.patch('/api/cabinet/company-profile-v2/set-first-step-show')
      }
    },
    created() {
      if (
        !this.hasVacancy ||
        !this.hasCompletedProfile ||
        !this.isHasVerifiedVacancy ||
        !this.hasPublishedVacancy ||
        !this.emailVerified
      ) return

      this.setShowed()
    }
  }
</script>

<style lang="less">

</style>
